import React, { forwardRef } from "react"
import { Toggle, Bar } from "./styles"

const Hamburger = forwardRef(({ open, onClick, label }, ref) => (
  <Toggle
    ref={ref}
    type="button"
    onClick={onClick}
    aria-expanded={open}
    aria-controls="mobile-nav"
    aria-label={label}
  >
    <Bar $open={open} $pos="top" />
    <Bar $open={open} $pos="mid" />
    <Bar $open={open} $pos="bottom" />
  </Toggle>
))

export default Hamburger
